import { useState } from 'react';
import { A } from '../router';
import { SITE } from '../siteMeta';

/** Baked at build for the prerendered pages; refreshes client-side on a new year. */
const COPYRIGHT_YEAR = new Date().getFullYear();

/**
 * The canonical Big Mech Energy Idle wordmark: BIG (white) MECH (teal) ENERGY
 * (yellow) IDLE (grey). Single source of truth for the logo color scheme; the
 * parent (.title, .site-brand, .hp2-title) owns size and any effects.
 */
export function Wordmark() {
  return (
    <span className="wordmark">
      <span className="wm-big">Big</span> <span className="wm-mech">Mech</span> <span className="wm-energy">Energy</span> <span className="wm-idle">Idle</span>
    </span>
  );
}

/**
 * Shared header and footer for the non-game pages. Real anchor links so
 * crawlers can walk the whole site from any page. On narrow screens (<=720px)
 * the link row collapses behind a hamburger.
 */
export function SiteNav({ suffix }: { suffix?: string }) {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);
  return (
    <nav className="site-bar">
      <div className="site-nav">
        <A to="/" className="site-brand plain" onClick={close}>
          <Wordmark />
          {suffix ? <span className="brand-suffix"> · {suffix}</span> : null}
        </A>
        <button
          type="button"
          className="site-burger"
          aria-expanded={open}
          aria-label={open ? 'Close menu' : 'Open menu'}
          onClick={() => setOpen((o) => !o)}
        >
          {open ? '✕' : '☰'}
        </button>
        <div className={`site-links ${open ? 'open' : ''}`}>
          <A to="/wiki" className="navlink" onClick={close}>Wiki</A>
          <A to="/faq" className="navlink" onClick={close}>FAQ</A>
          <a href={SITE.discordUrl} className="navlink" target="_blank" rel="noreferrer" onClick={close}>Discord</a>
          <A to="/play" className="btn primary" onClick={close}>Play free →</A>
        </div>
      </div>
    </nav>
  );
}

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="footer-links">
        <A to="/play" className="navlink">Play</A>
        <A to="/wiki" className="navlink">Wiki</A>
        <A to="/mechs" className="navlink">The Mechs</A>
        <A to="/faq" className="navlink">FAQ</A>
        <A to="/updates" className="navlink">Updates</A>
        <A to="/devlog" className="navlink">Devlog</A>
        <A to="/about" className="navlink">About</A>
        <A to="/press" className="navlink">Press kit</A>
        <a href={SITE.discordUrl} className="navlink" target="_blank" rel="noreferrer">Discord</a>
        <a href="/sitemap.xml" className="navlink">Sitemap</a>
        <a href="/llms.txt" className="navlink">llms.txt</a>
      </div>
      <p className="footer-note">
        Made by {SITE.devHandle}. A deterministic TypeScript core with procedural PixiJS art.
        No account, no ads, no purchases. Your save lives in your browser.
      </p>
      <p className="footer-copyright">© {COPYRIGHT_YEAR} {SITE.devHandle}. Big Mech Energy Idle. All rights reserved.</p>
    </footer>
  );
}
